import ScheduleList from "./ScheduleList";
import { SeasonTournaments } from "@/types/tournament";
import { sbBlok } from "@/types/sb-types";
import type { SeasonSummaryData } from "@/lib/seasonSummary";

export interface ScheduleProps {
  seasons: Array<SeasonTournaments>;
  seasonSummaries?: Array<sbBlok>;
  currentSeasonSummary?: SeasonSummaryData;
}

const Schedule = ({
  seasons,
  seasonSummaries,
  currentSeasonSummary,
}: ScheduleProps) => {
  const hasAnyTournaments = seasons?.some(
    ({ tournaments }) => tournaments?.length > 0
  );

  return (
    <div className="grid-container mb-9 lg:mb-[120px]">
      <div className="col-start-1 col-span-4 lg:col-start-2 lg:col-span-14 2xl:col-start-5 2xl:col-span-24">
        {hasAnyTournaments && (
          <section>
            <ScheduleList
              seasons={seasons}
              seasonSummaries={seasonSummaries}
              currentSeasonSummary={currentSeasonSummary}
            />
          </section>
        )}
      </div>
    </div>
  );
};

export default Schedule;
